module.exports = __webpack_public_path__ + "static/mindcraft-steering-5772dd182e3469e741011f32d59f6c0f.png";